import React, {useMemo} from 'react';
import {
  Col, Row,
} from 'antd';
import ItineraryHeader from '../../components/HeaderNavigation/ItineraryHeader';
import {
  Container,
} from './styles';
import {useParams} from "react-router-dom";
import RoadItinerary from "../../components/RoadItinerary";
import FlightItinerary from '../../components/FlightItinerary';

function Itinerary() {
  const { tripType } = useParams();

  const renderItinerary = () => {
    switch (tripType) {
      case 'road':
        return <RoadItinerary />;
      case 'flight':
        return <FlightItinerary />;
      case 'water':
        return <></>;
      default:
        return <></>;
    }
  }

  const headingName = useMemo(() => {
    switch (tripType) {
      case 'road':
        return 'Bus details';
      case 'flight':
        return 'Flight details';
      case 'water':
        return 'Water details';
      default:
        return '';
    }
  }, [tripType]);

  return (
    <Container>
      <div className="container">
        <Row>
          <Col span={24}>
            <ItineraryHeader name={headingName} stepText={tripType === 'road' ? "3 of 5" : "2 of 4"} />
          </Col>
        </Row>

        {renderItinerary()}
      </div>
    </Container>

  );
}

export default Itinerary;
